module.exports = __webpack_public_path__ + "img/helal-d.6698e36.webp";